import { APITypes } from '../../../primary-record-types';

export type ProfileItem =
    | APITypes.medicalProfileService.ProfileListItem
    | APITypes.medicalProfileService.GetProfileResponse
    | APITypes.organizationService.OrganizationMedicalProfileDetails;

export type SelectableProfileListItem = ProfileItem & {
    avatarUrl: string;
};

export const isProfileListItem = (profile: ProfileItem): profile is APITypes.medicalProfileService.ProfileListItem =>
    (profile as APITypes.organizationService.OrganizationMedicalProfileDetails).contactDetails === undefined;

export type ProfileSelectionState = {
    profiles: SelectableProfileListItem[];
    isLoadingProfiles: boolean;
    selectedProfileIds: string[];
    onToggleProfileId: (profileId: string) => void;
    onSetProfileIds: (profileIds: string[]) => void;
};
